module.exports = __webpack_public_path__ + "img/Slice9-min.e3650f75.png";